import { Originator } from './originator';
import { Memento } from './memento';

export class Caretaker<T = unknown> {
	private currentIndex = -1;
	private mementos: Memento<T>[] = [];
	private readonly originator: Originator<T>;

	constructor(originator: Originator<T>) {
		this.originator = originator;
	}

	save(): void {
		const memento = this.originator.saveToMemento();
		this.mementos = this.mementos.slice(0, this.currentIndex + 1);
		this.mementos.push(memento);
		this.currentIndex++;
	}

	undo(): void {
		if (this.currentIndex > 0) {
			this.originator.restore(this.mementos[--this.currentIndex]);
		}
	}

	redo(): void {
		if (this.currentIndex < this.mementos.length - 1) {
			this.originator.restore(this.mementos[++this.currentIndex]);
		}
	}
}
